BigInt.prototype.toJSON = function() {
  return this.toString();
};
const g = 18, a = (t, r = g) => {
  if (typeof t == "bigint")
    return (t * BigInt(10 ** (r || g))).toString();
  const s = typeof t == "number" ? t : Number.parseFloat(t);
  if (Number.isNaN(s))
    return console.error("toWei: invalid amount: ", t), "0";
  const o = typeof t == "string" && !t.includes("e") ? t : Intl.NumberFormat("en-US", {
    maximumFractionDigits: g,
    useGrouping: !1
  }).format(s), [e, n] = o.split(".").concat([""]);
  let i = n.replace(/0+$/, "");
  i.length > r && (i = i.slice(0, r));
  const l = `${e}${i}`, c = BigInt(l) * BigInt(10 ** r), u = Math.min(i.length, r);
  return c === BigInt(0) ? "0" : u === 0 ? c.toString() : c.toString().padStart(u, "0").slice(0, -u);
}, p = (t, r) => {
  if (r <= 0)
    return t.toString();
  const o = t.toString().padStart(r, "0"), e = o.slice(0, -r), n = o.slice(-r).replace(/\.?0+$/, "");
  return e === "" && n === "" ? "0" : e === "" ? `0.${n}` : n === "" ? e : `${e}.${n}`;
};
export {
  p as fromWei,
  a as toWei
};
//# sourceMappingURL=index.js.map
